import React, { useEffect, useState } from 'react';
import './DspDetails.css';
import MainContentWrapper from '../../Components/MainContentWrapper';
import { useLocation } from 'react-router';
import Drones from '../BhuMeetCustomerSuccess/Drones';
import ViewOperationDsp from './ViewOperationDsp';
import Requests from '../../AdminComponents/Requests/Requests';
import OperationsPilots from './OperationsPilots';
import Locations from './Locations/Locations';

function OperationDspDetails() {
    const [activeTab, setActiveTab] = useState(()=>{
        let savedFilters=localStorage.getItem("operationsDspDashBoardFilters");
        if(savedFilters){
            let parsedFilters = JSON.parse(savedFilters);
            return parsedFilters;
        }else {
            return 'details';
        }
    });
    const location = useLocation();
    const [dsp, setDsp] = useState(location.state?.dsp)

    useEffect(() => {
        console.log(location)
    },[])

    const tabs = ['details', 'drones', 'pilots', 'requests',"locations"];

    useEffect(()=>{
    localStorage.setItem('operationsDspDashBoardFilters',JSON.stringify(activeTab));
    },[activeTab])

    return (
        <div style={{ backgroundColor: "rgb(236, 239, 243)", overflow: "hidden" }} className='flex flex-col gap-5 h-[100%]  px-[20px] py-[50px]'>
            <div className="drone-tabs ">
                {tabs.map((tab) => (
                    <button
                        key={tab}
                        className={`tab-button ${activeTab === tab ? 'active' : ''}`}
                        onClick={() => setActiveTab(tab)}
                    >
                        {tab.charAt(0).toUpperCase() + tab.slice(1)}
                    </button>
                ))}
            </div>
            <div className="flex-grow overflow-y-auto">
                {activeTab === "details" ? (
                    <ViewOperationDsp dsp={dsp} notShow={location.state.notshow} callback={(dsp,isPanUpdate,isSubscription) => {
                        if(isPanUpdate){
                          setDsp((prev)=>({
                            ...prev,
                            operator_pan_url: dsp.pan_url,
                          }))
                        }else if(isSubscription){
                            setDsp((prev)=>({
                            ...prev,
                            subscription_details: dsp.subscription_details,
                          }))
                        }
                        else {
                            setDsp(dsp);
                        }
                        console.log("dsp after pan url changed ", dsp);
                    }} />
                ) : activeTab === "drones" ? (
                    <Drones dsp={dsp} />
                ) : activeTab === "requests" ? (
                    <Requests dsp={dsp} />
                ) : activeTab === "pilots" ? (
                    <OperationsPilots dsp={dsp} />
                ): activeTab === "locations" ? (
                    <Locations dsp={dsp} />
                ) : null}
            </div>
        </div>
    );
}

export default OperationDspDetails;